import {DateTime} from 'luxon';

export class NICEDNCRecord {
    totalRecords: number;
    recordId: number;
    createdBy: string;
    phoneNumber: string;
    formattedPhone: string;
    expiredDate: string;
    dateCollected: string;
    lastUpdateTime: string;

    constructor(dncJSON?: any) {
        if (dncJSON) {
            this.recordId = dncJSON.recordId || 0;
            this.createdBy = dncJSON.createdBy || '';
            this.phoneNumber = dncJSON.phoneNumber || '';
            this.formattedPhone = dncJSON.formattedPhone || '';
            this.expiredDate = dncJSON.expiredDate || '';
            this.dateCollected = dncJSON.dateCollected ? DateTime.now().toFormat('MM-dd-yyyy') : '';
            this.lastUpdateTime = dncJSON.lastUpdateTime || '';

        } else {
            this.recordId = 0;
            this.createdBy = '';
            this.phoneNumber = '';
            this.formattedPhone = '';
            this.expiredDate = '';
            this.dateCollected = DateTime.now().toFormat('MM-dd-yyyy');
            this.lastUpdateTime = DateTime.now().toFormat('MM-dd-yyyy');
        }
    }
}
